// extracted by mini-css-extract-plugin
module.exports = {"search-bar-input":"SearchBar_search-bar-input__2WeaQ","stretch":"SearchBar_stretch__1OwkZ"};